<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_BUTTON_GROUP_CLASS = `${PREFIX_CLASS}btn-group`
export default {
  name: 'TButtonGroup',
  props: {
    size: {
      type: String,
      default: '',
      validator (value) {
        return [ 'sm', 'lg', '' ].includes(value)
      }
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return [
        {
          [`${PREFIX_BUTTON_GROUP_CLASS}`]: !this.vertical,
          [`${PREFIX_BUTTON_GROUP_CLASS}-${this.size}`]: !!this.size,
          [`${PREFIX_BUTTON_GROUP_CLASS}-vertical`]: this.vertical
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// button-group.vue?cd4e4d40